import { Base64 } from 'js-base64';
import { Authenticate } from 'src/app/models/server/authenticate';
import { environment } from 'src/environments/environment';
import { ConnectedUsersStateService } from '../state/connected-users-state.service';

export class ServiceBase {
    /** URL pour le webService */
    public baseUrl;

    /**
     * Constructeur
     */
    constructor(public connectedUserStateService: ConnectedUsersStateService) {
        if (environment.production) {
            this.baseUrl = '';
        } else {
            this.baseUrl = environment.serverUrl;
        }
    }

    /**
     * Récupère l'id de l'organisation
     */
    public get organizationId(): string {
        return this.connectedUserStateService.getUserConnected().organization.id;
    }

    /**
     * Récupère les infomations sur l'utilisateur connecté
     */
    public get userConnected(): Authenticate {
        return this.connectedUserStateService.getUserConnected();
    }

    /**
     * Génération des entête
     * @param : Valeur du paramètre de l'entête
     */
    public getHeader(value: any) {
        return Base64.encode(JSON.stringify(value));
    }
}
